function Paginacao(props){

    const esconder = props.esconder;

    if (esconder) {
        return null;
    }

    return (
        <div class="row">
            <div class="col-12">
                    <nav aria-label="Page navigation example">
                        <ul class="pagination">
                            <li class="page-item prev-next"><button type="button" class="page-link">Previous</button></li>
                            <li class="page-item"><button type="button" class="page-link active">1</button></li>
                            <li class="page-item"><button type="button" class="page-link">2</button></li>
                            <li class="page-item"><button type="button" class="page-link">3</button></li>
                            <li class="page-item prev-next"><button type="button" class="page-link">Next</button></li>
                        </ul>
                    </nav>
            </div>
        </div>
    )
}

export default Paginacao;
